
export const PREFIX = 'template-case';
export const PREFIX_FORM_ITEM = `${PREFIX}-form-item`;
export const PREFIX_ANCHOR = `${PREFIX}-anchor`;
export const PREFIX_NOWRAP = `${PREFIX}-nowrap`;
export const PREFIX_INLINE_FLEX = `${PREFIX}-inline-flex`;
export const PREFIX_WRAPPER = `${PREFIX}-wrapper`;
export const PREFIX_HEADER = `${PREFIX}-header`;
export const PREFIX_BODYER = `${PREFIX}-bodyer`;
export const PREFIX_FOOTER = `${PREFIX}-footer`;
export const PREFIX_CHECK_ITEM_WRAPPER = `${PREFIX}-check-item-wrapper`;
export const PREFIX_GRID = `${PREFIX}-grid`;
export const PREFIX_GRID_LINE = `${PREFIX_GRID}-line`;
export const PREFIX_GRID_COLUMN = `${PREFIX_GRID}-column`;
export const CHECK_ITEM_ANIMATION_HIDDEN = 'check-item-animation-hidden';
export const CHECK_ITEM_DEIT = 'check-item-edit';

export const NOOP = () => { };
export const NOOP_PROMISE_RESOLVE = res => Promise.resolve(res);
export const NOOP_PROMISE_REJECT = res => Promise.reject(res);
export const STATUS_READONLY = Symbol('readonly'); // 只读状态
export const STATUS_CONFIG = Symbol('config'); // 配置状态
export const STATUS_NORMAL = Symbol('normal'); // 使用状态
export const SPECIALTY_EYE_GROUND = { // 专科检查眼底检查常规项
  data_od_disk: '界清、色红',
  data_od_cd: '0.3',
  data_od_macular: '中心凹反光可见',
  data_od_av: '2:3',
  data_od_retina: '视网膜平',
  data_os_disk: '界清、色红',
  data_os_cd: '0.3',
  data_os_macular: '中心凹反光可见',
  data_os_av: '2:3',
  data_os_retina: '视网膜平',
};
export const SPECIALTY_EYE_GROUND_NULL = { // 专科检查眼底检查清空
  data_od_disk: '',
  data_od_cd: '',
  data_od_macular: '',
  data_od_av: '',
  data_od_retina: '',
  data_os_disk: '',
  data_os_cd: '',
  data_os_macular: '',
  data_os_av: '',
  data_os_retina: '',
};
